export default [
  {
    path: '/electric_bill_conv_analysis',
    name: 'MarketingElectricBillConvAnalysis',
    component: () =>
      import(
        /* webpackChunkName: "MarketingElectricBillConvAnalysis" */ './MarketingElectricBillConvAnalysis.vue'
      )
  },
  {
    path: '/meter/report/kayin',
    name: 'ElectricReportforKayin',
    component: () =>
      import(/* webpackChunkName: "meter_report_kayin" */ './Kayin/index.vue')
  },
  {
    path: '/meter/report/shansouth',
    name: 'ElectricReportforShanSouth',
    component: () =>
      import(
        /* webpackChunkName: "meter_report_shansouth" */ './ShanSouth/index.vue'
      )
  },
  {
    path: '/meter/report/bagowest',
    name: 'ElectricReportforBagoWest',
    component: () =>
      import(
        /* webpackChunkName: "meter_report_bagowest" */ './BagoWest/index.vue'
      )
  },
  {
    path: '/meter/report/magway',
    name: 'ElectricReportforMagway',
    component: () =>
      import(/* webpackChunkName: "meter_report_magway" */ './Magway/index.vue')
  }
]
